//#region src/media/hls/resolve-url.ts
/** Resolve a potentially relative URL against a base URL using native URL API. */
function resolveUrl(url, baseUrl) {
	return new URL(url, baseUrl).href;
}
/**
* Default {@link ResolveKeyUri}: resolve only what names a fetchable resource, and hand anything opaque back untouched.
*
* Only `METHOD=AES-128` / `SAMPLE-AES` with `KEYFORMAT="identity"` points at a key file that may be written relative to
* the playlist. Every DRM key system instead carries an _identifier_ — a `data:` PSSH/PlayReady payload, a FairPlay
* `skd://` — and resolving those is at best lossy. It is also unsafe: FairPlay's common `skd://<keyid>:<iv>` form makes
* `new URL` read the IV as a port, which is not numeric, so it throws and takes the whole playlist parse down with it.
*/
function resolveKeyUri(uri, baseUrl) {
	if (/^[a-z][a-z0-9+.-]*:/i.test(uri) && !/^https?:/i.test(uri)) return uri;
	try {
		return resolveUrl(uri, baseUrl);
	} catch {
		return uri;
	}
}
//#endregion
export { resolveKeyUri, resolveUrl };
